import React from "react";
import { Paper, Skeleton } from "@mui/material";
import { ArrowForwardRounded } from "@mui/icons-material";

/**
 * NetSuite-style portlet card: compact header (icon + title, optional actions
 * on the right) over a body. Used to build the modern Home dashboard.
 * Props: { title, icon, actions, onOpen, loading, dense, className, children }
 * When `onOpen` is set, the header title becomes a clickable drill-through to
 * the related page (shows a hover state + arrow).
 */
const Portlet = ({ title, icon, actions, onOpen, loading = false, dense = false, className = "", children }) => {
  const headerLeft = (
    <>
      {icon && <span className="text-slate-500 shrink-0">{icon}</span>}
      <h3 className="text-[12px] font-bold uppercase tracking-wider text-slate-600 truncate group-hover:text-primary transition-colors">
        {title}
      </h3>
      {onOpen && (
        <ArrowForwardRounded className="!text-[15px] text-slate-300 group-hover:text-primary transition-colors shrink-0" />
      )}
    </>
  );

  return (
  <Paper className={`bg-white overflow-hidden ${className}`} style={{ boxShadow: "var(--shadow-xs)" }}>
    {(title || actions) && (
      <div className="flex items-center justify-between gap-2 px-3 py-2 border-b border-gray-100">
        {onOpen ? (
          <button
            type="button"
            onClick={onOpen}
            className="group flex items-center gap-2 min-w-0 text-start"
          >
            {headerLeft}
          </button>
        ) : (
          <div className="flex items-center gap-2 min-w-0">{headerLeft}</div>
        )}
        {actions && <div className="shrink-0 flex items-center gap-1">{actions}</div>}
      </div>
    )}
    <div className={dense ? "p-2" : "p-3"}>
      {loading ? (
        <div className="space-y-2">
          <Skeleton variant="rounded" height={28} />
          <Skeleton variant="rounded" height={28} width="80%" />
          <Skeleton variant="rounded" height={28} width="60%" />
        </div>
      ) : (
        children
      )}
    </div>
  </Paper>
  );
};

export default Portlet;
